import React from "react";
import "../styles/TabNavigation.css"; // we'll use a CSS file for hover styles

const TabNavigation = ({
  tabs,
  selectedTabId,
  setSelectedTabId,
  addTab,
  renameTab,
}) => (
  <div className="tab-navigation">
    {tabs.map((tab) => (
      <div key={tab.id} className="tab-item">
        <button
          className={`tab-btn ${selectedTabId === tab.id ? "active" : ""}`}
          onClick={() => setSelectedTabId(tab.id)}
        >
          {tab.title}
        </button>
        <button
          className="rename-btn"
          onClick={() => renameTab(tab.id)}
          title="Rename Tab"
        >
          edit✏️
        </button>
      </div>
    ))}
    <button className="tab-add" onClick={addTab}>
      + Add Tab
    </button>
  </div>
);

export default TabNavigation;
